/**
 * A lookup matched no row (deleted, archived, or RLS-hidden) — an expected
 * outcome, not a failure. The query layer skips retries and Sentry for it.
 */
export class RecordNotFoundError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'RecordNotFoundError'
  }
}
